import { type ReactNode } from "react";

interface Props {
  x: number;
  y: number;
  children: ReactNode;
}

const OFFSET = 12;
// Half of max-w-xs plus a margin, so a tooltip near an edge stays on screen
const EDGE_DISTANCE = 172;

export const ChartTooltip = ({ x, y, children }: Props) => (
  <div
    role="tooltip"
    className="bg-popover text-popover-foreground border-border pointer-events-none fixed z-50 w-max max-w-xs -translate-x-1/2 -translate-y-full rounded-md border px-3 py-2 text-xs shadow-md"
    style={{
      left: Math.min(
        Math.max(x, EDGE_DISTANCE),
        window.innerWidth - EDGE_DISTANCE,
      ),
      top: y - OFFSET,
    }}
  >
    {children}
  </div>
);
